var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":_vm.buttonVariant,"pill":""}},[_vm._v(" "+_vm._s(_vm.promotionDate)+" "),_c('b-badge',{staticClass:"mx-2",attrs:{"pill":"","variant":"success"}},[_vm._v(_vm._s(_vm.numberOfApproved))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }